type IconProps = {    
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>> 
}

export const Icon: React.FC<IconProps> = ({icon: Icon}) => {
    return(
        <Icon className="size-8 stroke-current text-dark_secondary dark:text-light_primary"/>
    )
}